
    
import { Component, Prop, Vue } from 'vue-property-decorator';

import { locationsInfoType } from '@/types/Common';
import FamilyLawMatterInstructions from "../files/FamilyLawMatterInstructions.vue";

@Component({
    components:{        
        FamilyLawMatterInstructions        
    }
})
export default class ArrangeForServiceFlmInstructions extends Vue {

    @Prop({required: true})
    applicationId!: string;

    @Prop({required: true})
    earlyResolution!: boolean;

    @Prop({required: true})
    instructionsStep!: string;
    
    @Prop({required: true})
    applicationLocationInfo!: locationsInfoType;

    displayInstructionsFile = false;    
    
    public onPrint() {
        const printId = "print-instructions";
        const pdfName = "instructions-for-filing-a-reply"; 
        const pdf_type = 'TEMP'; 
        const el= document.getElementById(printId);
        
        const bottomLeftText = `"Ministry of Attorney General \\a     Court Services Branch  ";`;
        const bottomRightText = `"Mailing address: ` + this.applicationLocationInfo.name +  `\\a ` + this.applicationLocationInfo.address +`\\a  "`;
        
        const url = '/survey-print/'+this.applicationId+'/?name=' + pdfName + '&pdf_type='+pdf_type+'&version=1.0&noDownload=true'
        const pdfhtml = Vue.filter('printPdf')(el.innerHTML, bottomLeftText, bottomRightText );
        
        const body = {
            'html':pdfhtml,
            'json_data':null
        }       
        
        const options = {
            responseType: "blob",
            headers: {
            "Content-Type": "application/json",
            }
        }  

        this.$http.post(url,body, options)
        .then(res => {
                this.onPrintSave(pdfName)
        },err => {
            console.error(err);        
        });
    }

    public onPrintSave(pdfName: string){        
        const url = '/survey-print/'+this.applicationId+'/?pdf_type=TEMP'
        const options = {
            responseType: "blob",
            headers: {
            "Content-Type": "application/json",
            }
        }
        this.$http.get(url, options)
        .then(res => {
            const blob = res.data;
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.download = pdfName;
            link.click();
            setTimeout(() => URL.revokeObjectURL(link.href), 1000);            
        },err => {
            console.error(err);
        });
    }    
}
